<template>
  <div class="crm-entry-index">
    <div class="entry-page-header">
      <div>
        <h2 class="entry-page-title">Kiểm duyệt mã thưởng</h2>

        <div class="entry-page-subtitle">
          <span
            class="socket-status-dot"
            :class="{
              connected: IsSocketConnected,
            }"
          ></span>

          {{
            IsSocketConnected ? "Đã kết nối realtime" : "Đang kết nối realtime"
          }}
        </div>
      </div>

      <div class="entry-header-actions">
        <a-button
          v-if="CanUseBrowserNotification"
          icon="bell"
          @click="EnableBrowserNotification"
        >
          Bật thông báo trình duyệt
        </a-button>
        <div class="entry-user-info">
          <div class="entry-user-greeting">
            <a-icon type="user" />

            <span>Xin chào</span>

            <strong>
              {{ UserDisplayName }}
            </strong>
          </div>
          <a-button type="link" icon="key" @click="ShowChangePassword = true">
            Đổi mật khẩu
          </a-button>

          <a-button icon="logout" type="danger" @click="Logout">
            Đăng xuất
          </a-button>

          <User_ChangePass v-model="ShowChangePassword" />

          <a-tooltip title="Đăng xuất">
            <a-button
              class="entry-logout-button"
              shape="circle"
              icon="logout"
              @click="Logout"
            />
          </a-tooltip>
        </div>
      </div>
    </div>
    <a-row :gutter="12" class="entry-statistics">
      <a-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
        <div
          class="entry-stat-card entry-stat-clickable"
          @click="ApplySummaryFilter('REVIEW')"
        >
          <div class="entry-stat-title">Cần xử lý</div>

          <div class="entry-stat-value">
            {{ Summary.Need_Review || 0 }}
          </div>
        </div>
      </a-col>

      <a-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
        <div
          class="entry-stat-card entry-stat-clickable"
          @click="ApplySummaryFilter('RE_REVIEW')"
        >
          <div class="entry-stat-title">Xử lý lại</div>

          <div class="entry-stat-value">
            {{ Summary.Re_Review || 0 }}
          </div>
        </div>
      </a-col>

      <a-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
        <div
          class="entry-stat-card entry-stat-clickable"
          @click="ApplySummaryFilter('PENDING_SUPERVISOR')"
        >
          <div class="entry-stat-title">Chờ Supervisor</div>

          <div class="entry-stat-value">
            {{ Summary.Pending_Supervisor || 0 }}
          </div>
        </div>
      </a-col>

      <a-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
        <div
          class="entry-stat-card entry-stat-clickable"
          @click="ApplySummaryFilter('MY_PROCESSED')"
        >
          <div class="entry-stat-title">Tôi xử lý hôm nay</div>

          <div class="entry-stat-value">
            {{ Summary.My_Processed_Today || 0 }}
          </div>
        </div>
      </a-col>

      <a-col v-if="IsManager" :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
        <div class="entry-stat-card entry-stat-card-voucher">
          <div class="entry-stat-title">Voucher còn trong kho</div>

          <div class="entry-stat-value">
            {{ Number(Summary.Voucher_Available || 0).toLocaleString() }}
          </div>
        </div>
      </a-col>
    </a-row>
    <!-- <a-row :gutter="12" class="entry-summary-row">
      <a-col :span="6">
        <a-card
          class="entry-summary-card"
          :bordered="false"
          @click="ApplySummaryFilter('REVIEW')"
        >
          <a-statistic
            title="Chờ kiểm duyệt"
            :value="Summary.Need_Review || 0"
          />
        </a-card>
      </a-col>

      <a-col :span="6">
        <a-card
          class="entry-summary-card"
          :bordered="false"
          @click="ApplySummaryFilter('RE_REVIEW')"
        >
          <a-statistic
            title="Cần kiểm duyệt lại"
            :value="Summary.Re_Review || 0"
          />
        </a-card>
      </a-col>

      <a-col :span="6">
        <a-card
          class="entry-summary-card"
          :bordered="false"
          @click="ApplySummaryFilter('PENDING_SUPERVISOR')"
        >
          <a-statistic
            title="Chờ Supervisor duyệt"
            :value="Summary.Pending_Supervisor || 0"
          />
        </a-card>
      </a-col>

      <a-col :span="6">
        <a-card
          class="entry-summary-card"
          :bordered="false"
          @click="ApplySummaryFilter('MY_PROCESSED')"
        >
          <a-statistic
            title="Tôi đã xử lý hôm nay"
            :value="Summary.My_Processed_Today || 0"
          />
        </a-card>
      </a-col>
      <a-col v-if="IsManager" :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
        <a-card size="small">
          <a-statistic
            title="Voucher còn trong kho"
            :value="Summary.Voucher_Available || 0"
          >
            <template #prefix>
              <a-icon type="gift" />
            </template>
          </a-statistic>
        </a-card>
      </a-col>
    </a-row> -->

    <a-card class="entry-filter-card" :bordered="false">
      <a-row :gutter="[10, 10]">
        <a-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
          <a-input
            v-model="Filter.Request_ID"
            allow-clear
            placeholder="Request ID"
            @pressEnter="Search"
          />
        </a-col>

        <a-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
          <a-input
            v-model="Filter.Phone"
            allow-clear
            placeholder="Số điện thoại"
            @pressEnter="Search"
          />
        </a-col>

        <a-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
          <a-input
            v-model="Filter.Full_Name"
            allow-clear
            placeholder="Họ và tên"
            @pressEnter="Search"
          />
        </a-col>

        <a-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
          <a-input
            v-model="Filter.Scratch_Code"
            allow-clear
            placeholder="Mã trúng thưởng"
            @pressEnter="Search"
          />
        </a-col>

        <a-col :xl="8" :lg="12" :md="16" :sm="24" :xs="24">
          <a-range-picker
            v-model="Filter.Date_Range"
            style="width: 100%"
            format="DD/MM/YYYY"
            :placeholder="['Từ ngày', 'Đến ngày']"
          />
        </a-col>

        <a-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
          <a-select
            v-model="Filter.Scratch_Statuses"
            mode="multiple"
            allow-clear
            placeholder="Trạng thái mã"
            style="width: 100%"
          >
            <a-select-option
              v-for="Item in FilterOptions.Scratch_Statuses"
              :key="Item.Value"
              :value="Item.Value"
            >
              {{ Item.Label }}
            </a-select-option>
          </a-select>
        </a-col>

        <a-col :xl="8" :lg="6" :md="8" :sm="12" :xs="24">
          <a-select
            v-model="Filter.Statuses"
            mode="multiple"
            allow-clear
            placeholder="Trạng thái Entry"
            style="width: 100%"
          >
            <a-select-option
              v-for="Item in FilterOptions.Statuses"
              :key="Item.Value"
              :value="Item.Value"
            >
              {{ Item.Label }}
            </a-select-option>
          </a-select>
        </a-col>

        <a-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
          <a-select
            v-model="Filter.AwardTypes"
            mode="multiple"
            allow-clear
            placeholder="Giải thưởng"
            style="width: 100%"
          >
            <a-select-option
              v-for="Item in FilterOptions.AwardTypes"
              :key="Item.Value"
              :value="Item.Value"
            >
              {{ Item.Label }}
            </a-select-option>
          </a-select>
        </a-col>

        <a-col
          :xl="12"
          :lg="18"
          :md="24"
          :sm="12"
          :xs="24"
          class="entry-filter-actions"
        >
          <a-button
            type="primary"
            icon="search"
            :loading="IsLoading"
            @click="Search"
          >
            Tìm kiếm
          </a-button>

          <a-button icon="reload" @click="ResetFilter"> Xóa lọc </a-button>
        </a-col>
        <!-- <a-col :xl="4" :lg="6" :md="8">
          <a-input
            v-model="Filter.Request_ID"
            allow-clear
            placeholder="Request ID"
            @pressEnter="Search"
          />
        </a-col>

        <a-col :xl="4" :lg="6" :md="8">
          <a-input
            v-model="Filter.Phone"
            allow-clear
            placeholder="Số điện thoại"
            @pressEnter="Search"
          />
        </a-col>

        <a-col :xl="4" :lg="6" :md="8">
          <a-input
            v-model="Filter.Full_Name"
            allow-clear
            placeholder="Họ và tên"
            @pressEnter="Search"
          />
        </a-col>

        <a-col :xl="5" :lg="8" :md="12">
          <a-range-picker
            v-model="Filter.Date_Range"
            style="width: 100%"
            format="DD/MM/YYYY"
            :placeholder="['Từ ngày', 'Đến ngày']"
          />
        </a-col>
        <a-col :xl="4" :lg="6" :md="8">
          <a-input
            v-model="Filter.Scratch_Code"
            allow-clear
            placeholder="Mã trúng thưởng"
            @pressEnter="ApplyFilter"
          />
        </a-col>
        <a-col :xl="4" :lg="6" :md="8">
          <a-select
            v-model="Filter.Scratch_Statuses"
            mode="multiple"
            allow-clear
            placeholder="Trạng thái mã"
            style="width: 100%"
          >
            <a-select-option
              v-for="Item in FilterOptions.Scratch_Statuses"
              :key="Item.Value"
              :value="Item.Value"
            >
              {{ Item.Label }}
            </a-select-option>
          </a-select>
        </a-col>

        <a-col :xl="4" :lg="6" :md="8">
          <a-select
            v-model="Filter.Statuses"
            mode="multiple"
            allow-clear
            placeholder="Trạng thái Entry"
            style="width: 100%"
          >
            <a-select-option
              v-for="Item in FilterOptions.Statuses"
              :key="Item.Value"
              :value="Item.Value"
            >
              {{ Item.Label }}
            </a-select-option>
          </a-select>
        </a-col>

        <a-col :xl="4" :lg="6" :md="8">
          <a-select
            v-model="Filter.AwardTypes"
            mode="multiple"
            allow-clear
            placeholder="Giải thưởng"
            style="width: 100%"
          >
            <a-select-option
              v-for="Item in FilterOptions.AwardTypes"
              :key="Item.Value"
              :value="Item.Value"
            >
              {{ Item.Label }}
            </a-select-option>
          </a-select>
        </a-col>

        <a-col :xl="7" :lg="12" :md="16" class="entry-filter-actions">
          <a-button
            type="primary"
            icon="search"
            :loading="IsLoading"
            @click="Search"
          >
            Tìm kiếm
          </a-button>

          <a-button icon="reload" @click="ResetFilter"> Xóa lọc </a-button>
        </a-col> -->
      </a-row>
      <a-row style="margin:-5px">
        <a-col style="display: flex !important; justify-content: flex-start !important;">
          <a-button
            v-if="IsManager || IsUser"
            type="danger"
            size="large"
            icon="plus"
            @click="ShowManualEntryModal = true"
          >
            Thêm KH trúng giải
          </a-button>
        </a-col>
      </a-row>
    </a-card>

    <a-card class="entry-table-card" :bordered="false">
      <a-table
        :columns="Columns"
        :data-source="Entries"
        :loading="IsLoading"
        :row-key="(Record) => Record.Request_ID"
        :pagination="Pagination"
        :scroll="{
          x: 1450,
          y: TableScrollHeight,
        }"
        :custom-row="CustomRow"
        size="middle"
        @change="HandleTableChange"
      >
        <template slot="Request_ID" slot-scope="Value, Record">
          <a-tag :color="GetScratchStatusColor(Record.Scratch_Status)">
            {{ Value }}
          </a-tag>
          <br />
          {{ Record.Created_At | moment("DD/MM/YYYY HH:mm:ss") }}
        </template>
        <template slot="IsCashout" slot-scope="Value, Record">
          <a-tag
            v-if="Record.Scratch_Status == 'Success'"
            :color="GetDistributeStatusObject(Record).Color"
          >
            <a-icon
              v-if="Record.IsCashout"
              type="dollar"
              style="color: #52c41a; font-size: 18px"
            />

            <a-icon
              v-else
              type="gift"
              style="color: #1890ff; font-size: 18px"
            />
            {{ GetDistributeStatusObject(Record).Message }}
          </a-tag>
          <!-- <a-tag v-if="Value == true && Record.SuperVisor_Cashout_Accept" :color="GetScratchStatusColor(Record.Scratch_Status)">
                        {{ Value?"" }}
                    </a-tag> -->
        </template>
        <!-- <template
                    slot="Created_At"
                    slot-scope="Value"
                >
                    {{ FormatDateTime(Value) }}
                </template> -->

        <template slot="Phone" slot-scope="Value, Record">
          {{ Record.Phone || Record.Zalo_ID || "-" }}
        </template>

        <template slot="Scratch_Code" slot-scope="Value, Record">
          <a-tag class="code_format">{{ Value }}</a-tag>
          <a-tag :color="GetScratchStatusColor(Record.Scratch_Status)">
            {{ GetScratchStatusLabel(Record.Scratch_Status) || "-" }}
          </a-tag>
        </template>

        <template slot="Status" slot-scope="Value, Record">
          <div v-if="Record.Scratch_Status === 'Success'">
            <a-tag :color="GetEntryStatusColor(Value)">
              {{ StatusLabels[Value] || Value || "-" }}
            </a-tag>

            <a-tag
              v-if="Record.Voucher_Distribution_DLR_Status"
              :color="GetDLRStatusColor(Record.Voucher_Distribution_DLR_Status)"
              style="margin-top: 4px"
            >
              {{ GetDLRStatusLabel(Record.Voucher_Distribution_DLR_Status) }}
            </a-tag>
          </div>
        </template>

        <template slot="Current_Step" slot-scope="Value">
          {{ StepLabels[Value] || Value || "-" }}
        </template>

        <template slot="Topup_Amount" slot-scope="Value">
          {{ FormatMoney(Value) }}
        </template>

        <template slot="Modified_At" slot-scope="Value">
          {{ Value | moment("DD/MM/YYYY HH:mm:ss") }}
        </template>

        <template slot="Action" slot-scope="Value, Record">
          <div @click.stop>
            <a-button size="small" icon="eye" @click="OpenEntry(Record)">
              Xem
            </a-button>

            <a-dropdown
              v-if="CanShowRowActions(Record)"
              class="row-action-dropdown"
            >
              <a-button size="small" style="margin-left: 6px">
                Thao tác
                <a-icon type="down" />
              </a-button>

              <a-menu slot="overlay">
                <a-menu-item
                  v-for="Action in Record.Available_Actions"
                  :key="Action.Code"
                  @click="RunRowAction(Record, Action)"
                >
                  {{ Action.Label }}
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
        </template>
      </a-table>
    </a-card>

    <EntryManualCreateModal
      :visible="ShowManualEntryModal"
      @close="ShowManualEntryModal = false"
      @created="OnManualEntryCreated"
    />

    <EntryDetailDrawer
      ref="EntryDetailDrawer"
      :visible="!!CurrentRequestID"
      :request-id="CurrentRequestID"
      @close="CloseEntry"
      @entry-updated="OnDetailEntryUpdated"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import CRMEntrySocket from "@/CRM_Entry_Socket";
import User_ChangePass from "@/components/User_ChangePass.vue";
import EntryDetailDrawer from "@/components/Entry/EntryDetailDrawer.vue";
import EntryManualCreateModal from "@/components/Entry/EntryManualCreateModal.vue";
import {  notification} from "ant-design-vue";

export default {
  name: "CRMEntryIndex",

  components: {
    EntryDetailDrawer,
    EntryManualCreateModal,
    User_ChangePass,
  },

  data() {
    return {
      IsLoading: false,
      IsSocketConnected: false,
      ShowChangePassword: false,
      ShowManualEntryModal: false,
      Entries: [],
      Summary: {},
      FilterOptions: {
        Scratch_Statuses: [],
        Statuses: [],
        AwardTypes: [],
      },

      Total: 0,
      Page: 1,
      PageSize: 30,

      Filter: {
        Request_ID: "",
        Phone: "",
        Full_Name: "",
        Scratch_Code: "",
        Date_Range: [],
        Scratch_Statuses: [],
        Statuses: [],
        AwardTypes: [],
      },

      Scratch_StatusColors: {
        SUCCESS: "#00CF00",
        WRONG: "#E5211D",
        DUPLICATE: "#FFA500",
        BLOCK: "#E5211D",
        BLACKLIST: "#E5211D",
        ENDDATE: "#E5211D",
        NOTYET: "#E5211D",
      },
      Scratch_StatusLabels: {
        SUCCESS: "Mã hợp lệ",
        WRONG: "Không chính xác",
        DUPLICATE: "Mã sử dụng",
        BLOCK: "KH tạm khóa",
        BLACKLIST: "KH đã khóa",
        ENDDATE: "CT Kết thúc",
        NOTYET: "CT Chưa bắt đầu",
      },
      StatusLabels: {
        IN_REVIEW: "Chờ kiểm duyệt",

        PENDING: "Chờ Supervisor",

        VERIFIED: "Đã xác minh",

        RE_REVIEW: "Kiểm duyệt lại",

        APPROVED: "Đã duyệt",

        GET_VOUCHER: "Đang lấy voucher",

        VOUCHER_ISSUED: "Lấy voucher thất bại",

        SENT_VOUCHER: "Đã lấy voucher",

        SENT_ISSUED: "Gửi voucher thất bại",

        COMPLETED: "Hoàn thành",

        REJECTED: "Từ chối",
      },

      StepLabels: {
        VerifiedCustInfo: "Xác minh thông tin khách hàng",

        SupReview: "Supervisor kiểm tra",

        SupApproved: "Supervisor đã duyệt",

        GetVoucher: "Đang lấy voucher",

        SentVoucher: "Đã lấy voucher / chờ gửi",

        VoucherDistributed: "Voucher đã được phân phối",

        Completed: "Hoàn thành",

        Rejected: "Đã từ chối",
      },

      Columns: [
        {
          title: "Request ID",
          dataIndex: "Request_ID",
          width: 140,
          fixed: "left",
          scopedSlots: {
            customRender: "Request_ID",
          },
        },
        // {
        //     title: 'Thời gian',
        //     dataIndex: 'Created_At',
        //     width: 155,
        //     scopedSlots: {
        //         customRender: 'Created_At'
        //     }
        // },
        {
          title: "Số điện thoại",
          dataIndex: "Phone",
          width: 70,
          scopedSlots: {
            customRender: "Phone",
          },
        },
        {
          title: "Họ và tên",
          dataIndex: "Full_Name",
          width: 100,
          ellipsis: true,
        },
        {
          title: "Mã dự thưởng",
          dataIndex: "Scratch_Code",
          width: 100,
          scopedSlots: {
            customRender: "Scratch_Code",
          },
        },
        // {
        //   title: "Trạng thái mã",
        //   dataIndex: "Scratch_Status",
        //   width: 70,
        //   scopedSlots: {
        //     customRender: "Scratch_Status",
        //   },
        // },
        {
          title: "Trạng thái Entry",
          dataIndex: "Status",
          width: 90,
          scopedSlots: {
            customRender: "Status",
          },
        },
        {
          title: "Trả Thưởng",
          width: 130,
          scopedSlots: {
            customRender: "IsCashout",
          },
        },
        // {
        //     title: 'Bước hiện tại',
        //     dataIndex: 'Current_Step',
        //     width: 130,
        //     scopedSlots: {
        //         customRender: 'Current_Step'
        //     }
        // },
        // {
        //     title: 'Giải thưởng',
        //     dataIndex: 'AwardType',
        //     width: 130
        // },
        // {
        //     title: 'Giá trị',
        //     dataIndex: 'Topup_Amount',
        //     width: 110,
        //     scopedSlots: {
        //         customRender: 'Topup_Amount'
        //     }
        // },
        {
          title: "User cuối",
          dataIndex: "Last_User",
          width: 70,
        },
        {
          title: "Cập nhật",
          dataIndex: "Modified_At",
          width: 155,
          scopedSlots: {
            customRender: "Modified_At",
          },
        },
        {
          title: "Action",
          key: "Action",
          width: 170,
          fixed: "right",
          scopedSlots: {
            customRender: "Action",
          },
        },
      ],
    };
  },

  computed: {
    oUser() {
      return this.$store.state.oUser || {};
    },

    UserDisplayName() {
      return (
        this.oUser.Full_Name ||
        this.oUser.FullName ||
        this.oUser.Name ||
        this.oUser.Username ||
        this.oUser.Usermame ||
        "Nhân viên"
      );
    },

    CurrentRequestID() {
      return this.$route.query.Request_ID || "";
    },

    Pagination() {
      return {
        current: this.Page,
        pageSize: this.PageSize,
        total: this.Total,
        showSizeChanger: true,
        pageSizeOptions: ["20", "30", "50", "100"],
        showTotal: (Total) => `Tổng ${Total} Entry`,
      };
    },

    TableScrollHeight() {
      return Math.max(window.innerHeight - 390, 300);
    },

    CanUseBrowserNotification() {
      return (
        typeof Notification !== "undefined" &&
        Notification.permission !== "granted"
      );
    },

    IsManager() {
      return (
        this.oUser.Role === "MANAGER" ||
        this.oUser.Role === "Manager" ||
        this.oUser.Role === "SUPERVISOR" ||
        this.oUser.Role === "SuperVisor"
      );
    },

    IsUser() {
      return this.oUser.Role === "USER" || this.oUser.Role === "User";
    },
  },

  created() {
    this.LoadInfo();
    this.InitSocket();
  },

  beforeDestroy() {
    CRMEntrySocket.Disconnect();
  },

  methods: {
    ...mapActions([
      "API_CRM_Entry_GetInfo",
      "API_CRM_Entry_Action",
      "API_Logout",
    ]),

    Logout() {
      CRMEntrySocket.Disconnect();
      this.API_Logout();
    },

    BuildGetInfoData() {
      const DateRange = this.Filter.Date_Range || [];

      return {
        Page: this.Page,
        PageSize: this.PageSize,

        Request_ID: this.Filter.Request_ID.trim(),

        Phone: this.Filter.Phone.trim(),

        Full_Name: this.Filter.Full_Name.trim(),
        Scratch_Code: this.Filter.Scratch_Code.toUpperCase().trim(),
        Date_From:
          DateRange[0] && DateRange[0].format
            ? DateRange[0].format("YYYY-MM-DD")
            : "",

        Date_To:
          DateRange[1] && DateRange[1].format
            ? DateRange[1].format("YYYY-MM-DD")
            : "",

        Scratch_Statuses: this.Filter.Scratch_Statuses,

        Statuses: this.Filter.Statuses,

        AwardTypes: this.Filter.AwardTypes,
      };
    },

    async LoadInfo() {
      this.IsLoading = true;

      try {
        const Result = await this.API_CRM_Entry_GetInfo(
          this.BuildGetInfoData(),
        );

        if (!Result || Result.State !== 1) {
          this.$message.error(
            Result && Result.Message
              ? Result.Message
              : "Không tải được danh sách Entry.",
          );

          return;
        }

        const Data = Result.Data || {};

        this.Entries = Data.Entries || Data.Rows || [];

        this.Total = Data.Total || 0;

        this.Summary = Data.Summary || {};

        if (Data.FilterOptions) {
          this.FilterOptions = Data.FilterOptions;
        }
      } catch (err) {
        this.$message.error("Không kết nối được máy chủ.");
      } finally {
        this.IsLoading = false;
      }
    },

    InitSocket() {
      CRMEntrySocket.Connect({
        Domain: this.$PRJ_DOMAIN,
        Token: this.oUser.Token,
        Username: this.oUser.Username || this.oUser.Usermame || "",

        OnConnected: () => {
          this.IsSocketConnected = true;
        },

        OnDisconnected: () => {
          this.IsSocketConnected = false;
        },

        OnEntryNew: (Payload) => {
          this.HandleSocketEntryNew(Payload);
        },

        OnEntryUpdated: (Payload) => {
          this.HandleSocketEntryUpdated(Payload);
        },

        OnEntryLog: (Payload) => {
          if (this.$refs.EntryDetailDrawer) {
            this.$refs.EntryDetailDrawer.ApplySocketLog(Payload);
          }
        },

        OnEntryPresence: (Payload) => {
          if (this.$refs.EntryDetailDrawer) {
            this.$refs.EntryDetailDrawer.ApplySocketPresence(Payload);
          }
        },

        OnSummaryUpdated: (Payload) => {
          if (Payload.Summary) {
            this.Summary = Payload.Summary;
          } else {
            this.Summary = {
              ...this.Summary,
              ...Payload,
            };
          }
        },
      });
    },

    HandleSocketEntryNew(Payload) {
      const Entry = Payload.Entry || Payload;

      if (!Entry || !Entry.Request_ID) {
        return;
      }

      if (this.Page === 1 && this.MatchCurrentFilter(Entry)) {
        const iIndex = this.Entries.findIndex(
          (Item) => Item.Request_ID === Entry.Request_ID,
        );

        if (iIndex === -1) {
          this.Entries.unshift(Entry);

          if (this.Entries.length > this.PageSize) {
            this.Entries.pop();
          }

          this.Total += 1;
        } else {
          this.$set(this.Entries, iIndex, {
            ...this.Entries[iIndex],
            ...Entry,
          });
        }
      }

      if (Payload.Summary) {
        this.Summary = Payload.Summary;
      }

      this.ShowNewEntryNotification(Entry);
    },

    HandleSocketEntryUpdated(Payload) {
      const Entry = Payload.Entry || Payload;

      if (!Entry || !Entry.Request_ID) {
        return;
      }

      const iIndex = this.Entries.findIndex(
        (Item) => Item.Request_ID === Entry.Request_ID,
      );

      if (iIndex !== -1) {
        const MergedEntry = {
          ...this.Entries[iIndex],
          ...Entry,
        };

        if (this.MatchCurrentFilter(MergedEntry)) {
          this.$set(this.Entries, iIndex, MergedEntry);
        } else {
          // Trạng thái thay đổi làm row không còn khớp filter.
          // Reload server để Total/pagination luôn chính xác.
          this.LoadInfo();
        }
      } else if (this.Page === 1 && this.MatchCurrentFilter(Entry)) {
        // Entry vừa chuyển vào filter hiện tại.
        this.LoadInfo();
      }

      if (Payload.Summary) {
        this.Summary = Payload.Summary;
      }

      if (this.$refs.EntryDetailDrawer) {
        this.$refs.EntryDetailDrawer.ApplySocketEntry(Payload);
      }
    },

    MatchCurrentFilter(Entry) {
      if (
        this.Filter.Request_ID &&
        !String(Entry.Request_ID || "").includes(this.Filter.Request_ID)
      ) {
        return false;
      }

      if (
        this.Filter.Phone &&
        !String(Entry.Phone || Entry.Zalo_ID || "").includes(this.Filter.Phone)
      ) {
        return false;
      }

      if (
        this.Filter.Full_Name &&
        !String(Entry.Full_Name || "")
          .toLowerCase()
          .includes(this.Filter.Full_Name.toLowerCase())
      ) {
        return false;
      }

      if (
        this.Filter.Statuses.length &&
        !this.Filter.Statuses.includes(Entry.Status)
      ) {
        return false;
      }

      if (
        this.Filter.Scratch_Statuses.length &&
        !this.Filter.Scratch_Statuses.includes(Entry.Scratch_Status)
      ) {
        return false;
      }

      if (
        this.Filter.AwardTypes.length &&
        !this.Filter.AwardTypes.includes(Entry.AwardType)
      ) {
        return false;
      }

      return true;
    },

    ShowNewEntryNotification(Entry) {
      if (!CRMEntrySocket.IsNotificationLeader()) {
        return;
      }

      notification.info({
        message: "Có Entry mới cần kiểm duyệt",

        description:
          `${Entry.Request_ID || ""}` +
          (Entry.Full_Name ? ` - ${Entry.Full_Name}` : ""),

        duration: 6,

        onClick: () => {
          this.OpenEntry(Entry);
        },
      });

      if (
        typeof Notification !== "undefined" &&
        Notification.permission === "granted" &&
        document.hidden
      ) {
        const BrowserNotification = new Notification(
          "Có Entry mới cần kiểm duyệt",
          {
            body:
              `${Entry.Request_ID || ""}` +
              (Entry.Full_Name ? ` - ${Entry.Full_Name}` : ""),

            tag: `crm-entry-${Entry.Request_ID}`,
          },
        );

        BrowserNotification.onclick = () => {
          window.focus();
          this.OpenEntry(Entry);
          BrowserNotification.close();
        };
      }
    },

    async EnableBrowserNotification() {
      if (typeof Notification === "undefined") {
        return;
      }

      const Permission = await Notification.requestPermission();

      if (Permission === "granted") {
        this.$message.success("Đã bật thông báo trình duyệt.");
      }
    },

    Search() {
      this.Page = 1;
      this.LoadInfo();
    },

    ResetFilter() {
      this.Filter = {
        Request_ID: "",
        Phone: "",
        Full_Name: "",
        Date_Range: [],
        Scratch_Code: "",
        Scratch_Statuses: [],
        Statuses: [],
        AwardTypes: [],
      };

      this.Page = 1;
      this.LoadInfo();
    },

    ApplySummaryFilter(Type) {
      this.Page = 1;

      if (Type === "REVIEW") {
        this.Filter.Statuses = ["IN_REVIEW", "RE_REVIEW"];
      }

      if (Type === "RE_REVIEW") {
        this.Filter.Statuses = ["RE_REVIEW"];
      }

      if (Type === "PENDING_SUPERVISOR") {
        this.Filter.Statuses = ["PENDING"];
      }

      if (Type === "MY_PROCESSED") {
        this.Filter.Statuses = [];
      }

      this.LoadInfo();
    },

    HandleTableChange(Pagination) {
      this.Page = Pagination.current;
      this.PageSize = Pagination.pageSize;

      this.LoadInfo();
    },

    CustomRow(Record) {
      return {
        on: {
          click: () => {
            this.OpenEntry(Record);
          },
        },
      };
    },

    OpenEntry(Entry) {
      if (!Entry || !Entry.Request_ID) {
        return;
      }

      const Request_ID = String(Entry.Request_ID);

      if (String(this.$route.query.Request_ID || "") === Request_ID) {
        return;
      }

      this.$router.replace({
        name: "CRM_Entry_Index",
        query: {
          ...this.$route.query,
          Request_ID: Request_ID,
        },
      });
    },

    CloseEntry() {
      const Query = {
        ...this.$route.query,
      };

      delete Query.Request_ID;

      this.$router.replace({
        name: "CRM_Entry_Index",
        query: Query,
      });
    },

    OnManualEntryCreated() {
      /*
       * Socket crm:entry:new cũng sẽ đẩy record về.
       * LoadInfo giúp summary/filter hiện tại đồng bộ ngay,
       * HandleSocketEntryNew đã chống duplicate bằng Request_ID.
       */
      this.Page = 1;
      this.LoadInfo();
    },

    OnDetailEntryUpdated(Entry) {
      if (!Entry || !Entry.Request_ID) {
        return;
      }

      const iIndex = this.Entries.findIndex(
        (Item) => Item.Request_ID === Entry.Request_ID,
      );

      if (iIndex !== -1) {
        this.$set(this.Entries, iIndex, {
          ...this.Entries[iIndex],
          ...Entry,
        });
      }
    },

    CanShowRowActions(Record) {
      return (
        this.IsManager &&
        Array.isArray(Record.Available_Actions) &&
        Record.Available_Actions.length > 0
      );
    },

    async RunRowAction(Record, Action) {
      if (Record.CCCD.length != 14) {
        this.$message.error("CCCD không hợp lệ, vui lòng kiểm tra lại.");

        return;
      }
      const Result = await this.API_CRM_Entry_Action({
        Request_ID: Record.Request_ID,

        Action: Action.Code,
      });

      if (!Result || Result.State !== 1) {
        this.$message.error(
          Result && Result.Message
            ? Result.Message
            : "Không thực hiện được thao tác.",
        );

        return;
      }

      this.$message.success(Result.Message || "Thao tác thành công.");

      if (Result.Data && Result.Data.Entry) {
        this.OnDetailEntryUpdated(Result.Data.Entry);
      }
    },

    FormatDateTime(Value) {
      if (!Value) {
        return "-";
      }

      const DateValue = new Date(Value);

      if (Number.isNaN(DateValue.getTime())) {
        return "-";
      }

      return DateValue.toLocaleString("vi-VN");
    },

    FormatMoney(Value) {
      const NumberValue = Number(Value || 0);

      if (!NumberValue) {
        return "-";
      }

      return NumberValue.toLocaleString("vi-VN");
    },

    GetScratchStatusColor(Scratch_Status) {
      return this.Scratch_StatusColors[Scratch_Status.toUpperCase()] || "#999";
    },
    GetScratchStatusLabel(Scratch_Status) {
      return (
        this.Scratch_StatusLabels[Scratch_Status.toUpperCase()] ||
        Scratch_Status ||
        "-"
      );
    },
    GetDLRStatusLabel(Status) {
      const Value = String(Status || "").toUpperCase();

      const Labels = {
        WAITING_DLR: "Voucher: Chờ xác nhận",
        DELIVERED: "Voucher: Đã giao",
        FAILED: "Voucher: Gửi thất bại",
      };

      return Labels[Value] || Value || "-";
    },

    GetDLRStatusColor(Status) {
      const Value = String(Status || "").toUpperCase();

      if (Value === "DELIVERED") return "green";
      if (Value === "FAILED") return "red";
      if (Value === "WAITING_DLR") return "orange";

      return "default";
    },

    GetDistributeStatusObject(oRetry) {
      try {
        if (oRetry.IsCashout) {
          return {
            Color: oRetry.IsDistributed ? "green" : "orange",
            Message: oRetry.IsDistributed
              ? "Đã trao Tiền mặt"
              : "Đang chờ trao Tiền mặt",
          };
        }

        const DLRStatus = String(
          oRetry.Voucher_Distribution_DLR_Status || "",
        ).toUpperCase();

        if (oRetry.IsDistributed || DLRStatus === "DELIVERED") {
          return {
            Color: "green",
            Message: "Đã gửi Voucher đến KH",
          };
        }

        if (DLRStatus === "FAILED") {
          return {
            Color: "red",
            Message:
              oRetry.Voucher_Distribution_DLR_Note ||
              "Gửi Voucher đến KH thất bại",
          };
        }

        if (DLRStatus === "WAITING_DLR") {
          return {
            Color: "orange",
            Message: "Đang gửi Voucher đến KH",
          };
        }

        if (oRetry.Status === "SENT_ISSUED") {
          return {
            Color: "red",
            Message:
              oRetry.Voucher_Distribution_Response_Message ||
              "Gửi Voucher sang đài thất bại",
          };
        }

        return {
          Color: "orange",
          Message: "Chưa gửi Voucher đến KH",
        };
      } catch (error) {
        return {
          Color: "orange",
          Message: "Có lỗi khi xử lý trạng thái",
        };
      }
    },

    GetEntryStatusColor(Status) {
      const Colors = {
        IN_REVIEW: "blue",
        PENDING: "gold",
        VERIFIED: "cyan",
        RE_REVIEW: "orange",
        APPROVED: "purple",
        GET_VOUCHER: "geekblue",
        VOUCHER_ISSUED: "volcano",
        SENT_VOUCHER: "blue",
        SENT_ISSUED: "magenta",
        COMPLETED: "green",
        REJECTED: "red",
      };

      return Colors[Status] || "default";
    },
  },
};
</script>

<style scoped>
.crm-entry-index {
  min-height: 100%;
  /* padding: 16px; */
  background: #f5f5f5;
}

.entry-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.entry-page-title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
}

.entry-page-subtitle {
  display: flex;
  align-items: center;
  margin-top: 4px;
  color: rgba(0, 0, 0, 0.45);
}

.socket-status-dot {
  width: 8px;
  height: 8px;
  margin-right: 6px;
  border-radius: 50%;
  background: #bfbfbf;
}

.socket-status-dot.connected {
  background: #52c41a;
}

.entry-summary-row {
  margin-bottom: 12px;
}

.entry-summary-card {
  cursor: pointer;
  transition: box-shadow 0.2s;
}

.entry-summary-card:hover {
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
}

.entry-filter-card {
  margin-bottom: 12px;
}

.entry-filter-actions {
  display: flex;
  gap: 8px;
}

.entry-table-card {
  min-height: 400px;
}

.row-action-dropdown {
  display: inline-block;
}
.entry-user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.entry-user-greeting {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 16px;
  white-space: nowrap;
}

.entry-user-greeting > span {
  color: rgba(0, 0, 0, 0.45);
  font-size: 13px;
}

.entry-user-greeting > strong {
  color: rgba(0, 0, 0, 0.85);
  font-size: 13px;
  font-weight: 600;
}

.entry-logout-button {
  flex: 0 0 auto;
}
.entry-statistics {
  margin-top: 12px;
  margin-bottom: 16px;
}

.entry-statistics > .ant-col {
  margin-bottom: 12px;
}

.entry-stat-card {
  min-height: 92px;
  padding: 14px 16px;

  background: #fff;

  border: 1px solid #e8e8e8;
  border-radius: 6px;

  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  justify-content: center;

  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.entry-stat-clickable {
  cursor: pointer;
}

.entry-stat-clickable:hover {
  border-color: #1890ff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.entry-stat-title {
  margin-bottom: 6px;

  font-size: 13px;
  line-height: 18px;
  font-weight: 500;

  color: rgba(0, 0, 0, 0.55);

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.entry-stat-value {
  font-size: 34px;
  line-height: 40px;
  font-weight: 700;

  color: rgba(0, 0, 0, 0.85);

  white-space: nowrap;
}

.entry-stat-card-voucher {
  border-left: 4px solid #52c41a;
}
.code_format {
  font-weight: bold;
}

.entry-stat-card-voucher .entry-stat-title {
  color: #389e0d;
}

.entry-stat-card-voucher .entry-stat-value {
  font-size: 36px;
  color: #389e0d;
}

@media (max-width: 1200px) {
  .entry-stat-card {
    min-height: 86px;
    padding: 12px 14px;
  }

  .entry-stat-value {
    font-size: 30px;
    line-height: 36px;
  }

  .entry-stat-card-voucher .entry-stat-value {
    font-size: 32px;
  }
}

@media (max-width: 768px) {
  .entry-statistics {
    margin-top: 10px;
    margin-bottom: 12px;
  }

  .entry-statistics > .ant-col {
    margin-bottom: 10px;
  }

  .entry-stat-card {
    min-height: 80px;
  }

  .entry-stat-value {
    font-size: 28px;
    line-height: 34px;
  }

  .entry-stat-card-voucher .entry-stat-value {
    font-size: 30px;
  }
}
</style>
